// ⚠️ 必须使用 HashRouter，禁止改为 BrowserRouter（部署平台挂载在子路径下，BrowserRouter 无法匹配）
import { HashRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { HomePage } from "@/pages/HomePage";
import { DemoPage } from "@/pages/DemoPage";

export function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/demo" element={<DemoPage />} />
      </Routes>
      <Toaster position="top-center" />
    </HashRouter>
  );
}
